import { render, staticRenderFns } from "./OfficeBasicInfo.vue?vue&type=template&id=237c264b&"
import script from "./OfficeBasicInfo.vue?vue&type=script&lang=ts&"
export * from "./OfficeBasicInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports